import pinia from '@/common/pinia'
import { useGlobalStore } from '@/stores/global'

Styxie.Initializers.Global = {
  index: (data) => {
    // make sure we use the same store as vue component will use
    // by passing root pinia instance
    const globalStore = useGlobalStore(pinia)
    globalStore.setGlobalData(data)
  }
}
